export const pageNameItemLocations = {
  '/signup/': 'sign_up.create_account',
  '/signup/confirm/': 'sign_up.confirm',
  '/signup/subscription-consent/': 'sign_up.consent',
  '/signup/customize-flow/': 'sign_up.survey',
  '/signup/toolkit-selection/': 'sign_up.toolkit_selection',
  '/signup/get-free-trial/': 'sign_up.price_plans',
  '/signup/invite/': 'sign_up.invite',
  '/signup/marketing-source/': 'sign_up.marketing_source',
  '/signup/info/': 'sign_up.info',
  '/signup/get-insights/': 'sign_up.insights',
  '/signup/project-info/': 'sign_up.domain',
  '/signup/enterprise/': 'sign_up.enterprise',
  '/signup/enterprise-demo/': 'sign_up.enterprise_demo',
  '/signup/insights/': 'sign_up.insights',
  '/product/success/': 'sign_up.product_success',
  '/product/fail/': 'sign_up.product_fail',
  '/subscribe/': 'sign_up.payment', // + /signup/get-free-trial/generated-offer-name/?offer=OFFER + /signup/get-subscription/?offer=OFFER
  '/signup/get-subscription/': 'sign_up.price_plans',
  '/signup/get-subscription/payment/': 'sign_up.payment',
  '/signup/desktop-recommended/': 'sign_up.desktop_recommended',
  '/signup/promo/': 'sign_up.promo',
  '/signup/facebook/': 'sign_up.facebook',
  '/signup/linkedin/': 'sign_up.linkedin',
  '/signup/email/': 'sign_up',
  '/login/': 'login.page',
  '/login/restore/': 'login.reset',
  '/login/change/': 'login.change',
  '/login/confirm/': 'login.confirm_password',
  '/login/2fa/': 'login.confirm',
  '/login/saml/': 'login.saml',
  '/login/saml-error/': 'login.saml_error',
  '/login/saml-success/': 'login.saml_success',
  '/login/disable_soft/': 'login.disable_soft',
  '/login/disable_hard/': 'login.disable_hard',
  '/login/disable/': 'login.disable',
};

export const getPageNameItemLocation = (pathname: string): string => {
  const pagePathName = pageNameItemLocations[pathname];

  if (!pagePathName) {
    const trialPageReg = new RegExp(/\/signup\/get-free-trial\/([\w-]+)/);
    const getSubscriptionPageReg = new RegExp(
      /\/signup\/get-subscription\/([\w-]+)/,
    );
    if (trialPageReg.test(pathname) || getSubscriptionPageReg.test(pathname)) {
      return pageNameItemLocations['/subscribe/'];
    }

    return 'sign_up';
  }

  return pagePathName;
};
